import { Controller } from "@hotwired/stimulus"

// Shows the allowance rule as a sentence while the form is filled in (same wording as AllowancesHelper).
export default class extends Controller {
  static targets = ["threshold", "amount", "activity", "output"]
  static values = { sentence: String, or: String, empty: String }

  connect() {
    this.update()
  }

  update() {
    const activities = this.activityTargets.filter((box) => box.checked).map((box) => box.dataset.label)
    const threshold = parseFloat(this.thresholdTarget.value)
    const amount = parseFloat(this.amountTarget.value)

    if (activities.length === 0 || !(threshold > 0) || !(amount > 0)) {
      this.outputTarget.textContent = this.emptyValue
      return
    }

    const locale = document.documentElement.lang
    this.outputTarget.textContent = this.sentenceValue
      .replace("%{activities}", this.list(activities))
      .replace("%{threshold}", threshold.toLocaleString(locale))
      .replace("%{amount}", amount.toLocaleString(locale, { style: "currency", currency: "EUR" }))
  }

  list(names) {
    if (names.length < 2) return names.join("")
    return `${names.slice(0, -1).join(", ")} ${this.orValue} ${names[names.length - 1]}`
  }
}
